var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item-group',{attrs:{"color":"primary"}},[_c('v-list-item',{on:{"click":_vm.exit}},[_c('v-list-item-title',[_c('v-icon',{staticClass:"mr-2",attrs:{"medium":""}},[_vm._v(" mdi-logout ")]),_vm._v(" Sair ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }